import React from 'react';
import { motion } from 'framer-motion';
import { 
  SiNodedotjs, SiReact, SiMongodb, SiExpress, 
  SiRabbitmq, SiJavascript, SiGit
} from 'react-icons/si';
import { FaAws, FaRobot, FaLink, FaDatabase } from 'react-icons/fa';

const skills = [
  { name: 'Node.js', icon: SiNodedotjs, color: '#339933' },
  { name: 'JavaScript', icon: SiJavascript, color: '#F7DF1E' },
  { name: 'MongoDB', icon: SiMongodb, color: '#47A248' },
  { name: 'RabbitMQ', icon: SiRabbitmq, color: '#FF6600' },
  { name: 'Express.js', icon: SiExpress, color: '#FFFFFF' },
  { name: 'AWS', icon: FaAws, color: '#FF9900' },
  { name: 'React', icon: SiReact, color: '#61DAFB' },
  { name: 'AI Agents', icon: FaRobot, color: '#412991' },
  { name: 'RAG', icon: FaDatabase, color: '#00ADD8' },
  { name: 'LangChain', icon: FaLink, color: '#10B981' },
  { name: 'Git', icon: SiGit, color: '#F05032' },
];

const Skills = () => {
  return (
    <section id="skills" className="py-24 bg-slate-950">
      <div className="max-w-6xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="font-display text-3xl md:text-4xl font-bold mb-4">Technical Arsenal</h2>
          <p className="text-slate-400">Tools and technologies I use to build premium scalable products</p>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-6">
          {skills.map((skill, index) => (
            <motion.div
              key={skill.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="glass-card p-6 rounded-xl flex flex-col items-center justify-center gap-4 hover:border-indigo-500/50 transition-colors group"
            >
              <skill.icon 
                className="text-4xl transition-transform group-hover:scale-110 duration-300" 
                style={{ color: skill.color }} 
              />
              <span className="font-medium text-slate-300 text-sm text-center">{skill.name}</span>
            </motion.div>
          ))}
        </div>

        <div className="mt-16 grid md:grid-cols-2 gap-8">
           <div className="p-6 rounded-2xl bg-gradient-to-br from-indigo-900/20 to-slate-900 border border-indigo-500/20">
             <h3 className="text-xl font-bold text-white mb-4">Core Strengths</h3>
             <ul className="space-y-4 text-slate-400">
               <li className="flex items-start gap-3">
                 <span className="w-1.5 h-1.5 bg-indigo-500 rounded-full mt-2 shrink-0"></span>
                 <div>
                   <strong className="text-slate-300 block">AI & Emerging Tech</strong>
                   <span className="text-sm">Actively building AI powered products and AI Agents leveraging the latest advancements in Gen AI.</span>
                 </div>
               </li>
               <li className="flex items-start gap-3">
                 <span className="w-1.5 h-1.5 bg-indigo-500 rounded-full mt-2 shrink-0"></span>
                 <div>
                   <strong className="text-slate-300 block">Collaboration</strong>
                   <span className="text-sm">Co-led the implementation of RabbitMQ based async processing workflows, improving system reliability.</span>
                 </div>
               </li>
             </ul>
           </div>
           
           <div className="p-6 rounded-2xl bg-gradient-to-br from-indigo-900/20 to-slate-900 border border-indigo-500/20">
             <h3 className="text-xl font-bold text-white mb-4">Leadership & Execution</h3>
             <ul className="space-y-4 text-slate-400">
               <li className="flex items-start gap-3">
                 <span className="w-1.5 h-1.5 bg-cyan-500 rounded-full mt-2 shrink-0"></span>
                 <div>
                   <strong className="text-slate-300 block">Technical Leadership</strong>
                   <span className="text-sm">Led interns, mentoring them in best coding practices and optimizing backend efficiency. Managed client interactions smoothly.</span>
                 </div>
               </li>
               <li className="flex items-start gap-3">
                 <span className="w-1.5 h-1.5 bg-cyan-500 rounded-full mt-2 shrink-0"></span>
                 <div>
                   <strong className="text-slate-300 block">Ownership & Execution</strong>
                   <span className="text-sm">Delivered high impact integrations including Stripe subscription management and domain reseller services.</span>
                 </div>
               </li>
             </ul>
           </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;